import { render } from "./Contacts.vue?vue&type=template&id=07eba574&scoped=true"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"

import "./Contacts.vue?vue&type=style&index=0&id=07eba574&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07eba574"],['__file',"src/assets/js/pages/AddGate/Contacts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07eba574"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07eba574', __exports__)) {
    api.reload('07eba574', __exports__)
  }
  
  module.hot.accept("./Contacts.vue?vue&type=template&id=07eba574&scoped=true", () => {
    api.rerender('07eba574', render)
  })

}


export default __exports__